import ReportPage from "../../components/ReportPage";
import { downloadTotalDistributionByBanner } from "../../API";

const schema = {
  title: "Total Distribution by Banner",
  params: [
    { name: "banners", label: "Banners", type: "multiselect", route: "banners", fields: ["name"], payloadKey: "bannerIds" },
    {
      name: "products",
      label: "Products",
      type: "multiselect",
      route: "products",
      cascadesFrom: "manufacturer",
      fields: ["description", "formatQut", "format"],
      payloadKey: "productIds",
      buildQueryFn: (manufacturer, commonParams, localValues) => {
        const status = localValues?.productStatus?.id ?? commonParams.itemStatus ?? "ACTIVE";
        const statusSearch = status === "ALL" ? "" : `,status:${status}`;
        return `?search=manufacturer:${manufacturer.id}${statusSearch}&size=1000`;
      },
    },
  ],
  downloadFn: downloadTotalDistributionByBanner,
};

export default function TotalDistributionByBannerReport() {
  return <ReportPage schema={schema} />;
}
